exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-menu-item.is-disabled {\n\topacity: 1;\n}\n", ""]);

// exports
